import React, { useRef } from 'react';
import { useId } from "react-id-generator";
import FormRow from 'commons/components/FormFields/FormRow';
import MaskedInput from 'commons/components/MaskedInput/MaskedInput';

interface MaskedInputFieldProps {
    className?: string,
    disabled?: boolean,
    fieldIcon?: any,
    error?: string,
    id?: string,
    label?: string,
    mask: string[],
    name?: string,
    rowClassName?: string,
    touched?: boolean,
    type?: string,
}

function MaskedInputField(props: MaskedInputFieldProps) {

    const inputId = props.id ?? useId(1, "inputField-")[0];
    const inputRef = useRef();
    const inputProps = Object.assign({}, props);

    // Remove props not used by the HTML <input>
    delete inputProps.error;
    delete inputProps.fieldIcon;
    delete inputProps.rowClassName;
    delete inputProps.touched;

    return (
        <FormRow 
            className={props.rowClassName}
            disabled={props.disabled}
            error={props.error}
            fieldIcon={props.fieldIcon}
            idPrefix={props.name}
            inputId={inputId}
            label={props.label}
            touched={props.touched}
            type={props.type}
        >
            <MaskedInput 
                {...inputProps}
                className={`input-field ${props.className}`}
                data-testid={inputId}
                disabled={props.disabled}
                id={inputId}
                ref={inputRef}
                type={props.type}
            />
        </FormRow>
    );

}

MaskedInputField.defaultProps = {
    disabled: false,
    touched: false,
    type: "text"
}

export default MaskedInputField;